<template lang="pug">
v-col(cols="12")
  v-card(outlined)
    v-toolbar(flat color="accent").white--text
      div.d-flex.flex-grow-1
        p.title.mb-0.mr-auto Чат с поддержкой
        v-btn.rounded.align-self-start(
          fab
          x-small
          @click="showChat = !showChat"
          color="primary"
        )
          v-icon {{ showChat ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
    v-expand-transition
      div(v-if="showChat")
        application-chat(
          :messages="messages"
        )
        div
          .pa-2
            app-editor(v-model="form.text" filled)
          v-divider
          .pa-2.d-flex(style="overflow-x:auto")
            uploader(@upload="uploadFile($event)")
              template(#activator="{ loading }")
                v-btn.mr-4(
                  :loading="loading"
                  color="success"
                  height="120px"
                  width="120px"
                )
                  .d-flex.flex-column
                    v-icon mdi-plus
                    span.caption Добавить файл
            Element(
              v-for="(file, index) in files"
              :key="index"
              :show-edit="false"
              show-actions
              :name="file.original_name"
              :url="file.url"
              @delete="files.splice(index, 1)"
            )
          v-divider
          .pa-2
            v-btn(
              @click="sendMessage"
              :dislabed="!form.text"
              color="success"
            ) Отправить
</template>

<script>
import { isImage } from '@/lib';
import { CRUDInternalChats, CRUDInternalChatMessages } from '@/services/API/_crud';
import AppEditor from '@/components/AppEditor.vue';
import Uploader from '@/components/core/Uploader.vue';
import Element from '@/components/icons/Element.vue';
import ApplicationChat from '@/modules/Question/components/ApplicationChat.vue';

const DEFAULT_FORM  = {
  text:'',
  files: {
    images: [],
    documents: [],
  },
};

export default {
  components:{
    AppEditor,
    Uploader,
    Element,
    ApplicationChat,
  },
  props:{
    question: { type:Object, required: true },
  },

  data() {
    return {
      showChat:false,

      chat: null,
      messages: [],
      files: [],
      form :{ ...DEFAULT_FORM },
    };
  },
  created() {
    this.init();
  },

  methods:{
    async init() {
      await this.fetchInternalChat();
      await this.fetchInternalChatMessages();
    },

    async fetchInternalChat() {
      try {
        const params = {
          'search[target_id]':  this.question.id,
          'search[type]:': 2,
        };
        const response = await CRUDInternalChats.getAll(params);
        const [chat] = response.data.data;
        this.chat = chat;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async fetchInternalChatMessages() {
      try {
        const params = { 'search[internal_chat_id]': this.chat.id };
        const response = await CRUDInternalChatMessages.getAll({ 'expand': 'images, documents', ...params });
        this.messages = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
    uploadFile(file) {
      this.files.push(file);
      if (isImage(file.file_name)) {
        this.form.files.images.push(file.file_name);
      } else {
        this.form.files.documents.push(file.file_name);
      }
    },
    async sendMessage() {
      try {
        const params = {
          'internal_chat_id': this.chat.id,
          'text': this.form.text,
          'images': [
          ],
          'documents': [
          ],
        };
        params.images = this.form.files.images;
        params.documents = this.form.files.documents;
        const response = await CRUDInternalChatMessages.create({ 'expand': 'images, documents', ...params });
        this.messages.push(response.data.data);
        this.form = { ...DEFAULT_FORM };
        this.files.length = 0;
        this.$toast.success('Сообщение отправлено');
      } catch (err) {
        this.$toast.error(err.response.data.result_message);
      }
    },
  },

};
</script>

<style>

</style>
